import * as actions from './pointsManager.actions'

const initialState = {
  value: null,
  icon: '',
  style: {},
}

const actionsMap = {
  [actions.SET_POINTS_DATA]: (state, action) => {
    return {
      ...state,
      ...action.data,
    }
  },
  [actions.RESET_POINTS_DATA]: (state) => {
    return {
      ...state,
      value: null,
      icon: '',
      style: {},
    }
  },
}

/* eslint require-jsdoc: 0 */
export default function reducer(state = initialState, action = {}) {
  const fn = actionsMap[action.type]
  return fn ? fn(state, action) : state
}
